import React from 'react';
import emailjs from 'emailjs-com';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaLinkedin
} from 'react-icons/fa';
import {
  FooterContainer,
  FooterSubscription,
  FooterSubText,
  FooterSubHeading,
  Form,
  FormInput,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  SocialIcon,
  WebsiteRights,
  SocialIcons,
  SocialIconLink,
  FormTextArea
} from './Footer.elements';


function Footer() {
  const enviarMail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_o84gt7h', 'template_dhxfgx5', e.target, 'user_rYkDJOfzhhh7PVS9fk2sd')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });

    e.target.reset()
  }

  return (
    <FooterContainer id='our-estimations'>
      <FooterSubscription>
        <FooterSubHeading>
          Comenzá hoy a transformar ideas en proyectos reales.
        </FooterSubHeading>
        <FooterSubText >Completa los campos siguientes para recibir una cotizacion de tu proyecto.</FooterSubText>
        <Form onSubmit={enviarMail}>
          <FormInput name='name' type='text' placeholder='Ingresar Nombre' required />
          <FormInput name='lastname' type='text' placeholder='Ingresar Apellido' required />
          <FormInput name='projectName' type='text' placeholder='Ingresar Nombre del proyecto' required />
          <FormInput name='email' type='email' placeholder='Ingresar Email' required />
          <FormInput name='phone_number' type='text' placeholder='Ingrese su numero' required />
          <FormTextArea name='description' type='text' placeholder='Descripcion breve...' required />
          <FormInput name='button' type='submit' value='Enviar' placeholder='Ingrese su numero' required />
        </Form>
        <FooterSubHeading>
          Cotizá tu proyecto comunicandote a través de las redes sociales
        </FooterSubHeading>
      </FooterSubscription>

      <FooterLinksContainer>
        <FooterLinksWrapper>
          <SocialIcons>
            <SocialIconLink href='/' target='_blank' aria-label='Facebook'>
              <FaFacebook />
            </SocialIconLink>
            <SocialIconLink href='/' target='_blank' aria-label='Instagram'>
              <FaInstagram />
            </SocialIconLink>
            <SocialIconLink
              href={
                '//www.youtube.com/channel/UCsKsymTY_4BYR-wytLjex7A?view_as=subscriber'
              }
              rel='noopener noreferrer'
              target='_blank'
              aria-label='Youtube'
            >
              <FaYoutube />
            </SocialIconLink>
            <SocialIconLink href='/' target='_blank' aria-label='Twitter'>
              <FaTwitter />
            </SocialIconLink>
            <SocialIconLink href='/' target='_blank' aria-label='LinkedIn'>
              <FaLinkedin />
            </SocialIconLink>
          </SocialIcons>

        </FooterLinksWrapper>
        <FooterLinksWrapper>


        </FooterLinksWrapper>
      </FooterLinksContainer>
      <SocialMedia>
        <SocialMediaWrap>
          <SocialLogo to='/'>
            <SocialIcon />
            GroundWire
          </SocialLogo>
          <WebsiteRights>GroundWire © 2021 - Todos los derechos reservados</WebsiteRights>

        </SocialMediaWrap>
      </SocialMedia>
    </FooterContainer>
  );
}

export default Footer;
